<template lang="pug">
  Modal(ref="modal" title="Update Contact Information" closable="true")
    .update-contact-info-modal-body.ssp-form-horizontal
      .form-group
        label.ic-label Email
        .ic-control
          input.form-control.name-input.focus(type="text" v-model="email")
      .form-group
        label.ic-label Phonenumber
        .ic-control
          input.form-control.name-input.focus(type="text" v-model="phonenumber")
    div(slot="footer")
      button.btn.btn-primary(@click="updateInformation()") Update
      button.btn.btn-default(@click="$refs.modal.cancel()") Close
</template>

<script>
import miniToastr from 'mini-toastr'
import Modal from '@/components/common/Modal'
import TrackNTrace from '@/service/apis/TrackNTrace'

export default {
  data: () => ({
    email: null,
    phonenumber: null,
    locationId: null
  }),
  methods: {
    open(locationId) {
      this.locationId = locationId
      TrackNTrace.getLocation(locationId)
        .then((resp) => {
          if (resp.data.fixedLocation.contactInfo) {
            this.email = resp.data.fixedLocation.contactInfo.email
            this.phonenumber = resp.data.fixedLocation.contactInfo.phoneNumber
          }
        })
        .catch((e) => { this.$emit('error', e) })
      this.$refs.modal.open();
    },
    updateInformation() {
      const req = {
        email: this.email,
        locationId: this.locationId,
        phoneNumber: this.phonenumber
      }

      TrackNTrace.updateLocationContactInformation(this.locationId, req)
        .then(() => {
          this.$refs.modal.cancel()
          miniToastr.success('Contact information updated')
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.update-contact-info-modal-body {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/ContactInformationModal.vue